import { createFileRoute } from "@tanstack/react-router";
import { BottomNav } from "@/components/BottomNav";
import { Button } from "@/components/ui/button";
import { Home, SearchX } from "lucide-react";

export const Route = createFileRoute("/404")({
  head: () => ({
    meta: [
      { title: "Page Not Found — PataTasks" },
      { name: "description", content: "The page you are looking for does not exist." },
    ],
  }),
  component: NotFoundPage,
});

function NotFoundPage() {
  return (
    <div className="bg-background min-h-screen pb-20 md:pb-0">
      <main className="flex flex-col items-center justify-center px-4 py-20 text-center">
        <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-blue-50 text-blue-600">
          <SearchX className="h-10 w-10" />
        </div>
        <h1 className="text-3xl font-bold text-foreground mb-2">404</h1>
        <p className="text-slate-600 mb-6 max-w-md">
          Sorry, the page you are looking for does not exist or has been moved.
        </p>
        <div className="flex gap-3">
          <Button onClick={() => window.history.back()} variant="outline">
            Go Back
          </Button>
          <Button asChild>
            <a href="/">
              <Home className="mr-2 h-4 w-4" />
              Go Home
            </a>
          </Button>
        </div>
      </main>
      <BottomNav />
    </div>
  );
}
